const message = {
  searchCity: "Search City",
  domestic: "Domestic",
  abroad: "Abroad",
};

export default message;
